import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

export const s = StyleSheet.create({
	// Shrinks to the cell row and centers within the field, so a short scale (e.g. 1–5) isn't
	// stretched full-width — it keeps the same fixed gap a 0–10 scale has and sits centered.
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		width: 'fit-content',
		maxWidth: '100%',
		margin: '0 auto',
	},
	// Fixed-size cells with a constant gap regardless of count; centered, and wraps when too narrow.
	// The end-label row stretches to this row's width, so the labels align with the first/last cells.
	scale: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'center',
		gap: THEME.spacing.sm,
	},
	cell: {
		flex: '0 0 auto',
		width: 40,
		height: 40,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		border: `1px solid ${THEME.colors.primary.main}`,
		borderRadius: THEME.common.borderRadius,
		background: THEME.colors.background.light,
		color: THEME.colors.primary.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		fontFamily: THEME.typography.fontFamilies.lexend,
		cursor: 'pointer',
		userSelect: 'none',
		transition: 'background 0.15s, color 0.15s',
		':hover:not([data-pressed]):not(:disabled)': {
			background: THEME.colors.hover.light,
		},
		':is([data-pressed])': {
			background: THEME.colors.primary.main,
			color: THEME.colors.primary.contrastText,
		},
		':disabled': {
			opacity: 0.6,
			pointerEvents: 'none',
			cursor: 'default',
		},
	},
	labels: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: THEME.spacing.md,
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
});
